import type { IVoyageCrew } from './voyageCrew'
import { voyageSystems_rack } from './voyageSystems_rack-sidecar'

export function onEnter(obj: IVoyageCrew) {
  voyageSystems_rack.swapItemHere(obj, true)
}
